import { render, staticRenderFns } from "./AssignChain.vue?vue&type=template&id=4d83d607&lang=pug"
import script from "./AssignChain.vue?vue&type=script&lang=js"
export * from "./AssignChain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports